// @flow
import connectWebActions             from 'fg-frontend/src/webComponents/connectWebActions';
import { connectWebComponents }      from 'fg-frontend/src/webComponents/decorate';
import autoTitleLinksWithBlankTarget from 'fg-frontend/src/components/autoTitleLinksWithBlankTarget';
import safeBlankLinks                from 'fg-frontend/src/components/safeBlankLinks';

import configureWebComponents from './configureWebComponents';
import configureWebActions    from './configureWebActions';
import resizeEndEvent         from './webActions/resizeEndEvent';
// import cookiesPolicy          from 'fg-frontend/components/CookiesPolicy/index';
// import cookiesPolicy          from './components/CookiesPolicy/index';
import phoneLink              from './components/PhoneLink';
import 'fg-frontend/ramjet/liveValidation';
// import('./components/plUpload/fg.upload');                // PL upload
// import 'bootstrap/js/dist/collapse';

connectWebComponents(configureWebComponents);
connectWebActions(configureWebActions, [ 'keyup' ]);
autoTitleLinksWithBlankTarget();
// cookiesPolicy({ enableCloseButton: true, enableTechnicalButton: true, enableSplitGTMContainer: true });
phoneLink();
resizeEndEvent();

// Mastaveni atributu 'noopener' vsem target="_blank" odkazum, ktere ho nemaji
safeBlankLinks();



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureWeb.js